/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Weather',dictionary:{"de":{"general":{"name":"Name","description":"Bezeichnung"},"isAdverse":"Schlechtwetter"},"en":{"general":{"name":"Name","description":"Description"},"isAdverse":"Adverse Weather"}}})
import { Login } from './Login';

export class Weather extends _BaseModel {
	
	static toString() {
		return 'Weather'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Weather.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Weather', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Weather.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Weather', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Weather.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Weather', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Weather', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Weather', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Weather.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Weather', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Weather'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Weather) || _BaseModel.t('rules.reference', {modelName:'Weather', path:'meta.currentDocument'}) ],
				model: Weather,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Weather', path:'meta.revisions'}) ],
				model: Weather,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Weather.general.name'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Weather', path:'general.name'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Weather', path:'general.name'}) ],
},
    
	},
	
					
	description:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.Weather.general.description'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Weather', path:'general.description'}) ],
},
    
	},
	
},
				
	isAdverse:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Weather.isAdverse'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Weather', path:'isAdverse'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Weather._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, general={}, isAdverse=false, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.general=GeneralClass.create(general);
		this.isAdverse=isAdverse;
		this._id=_id;
	}

	static create(data) {
		return new Weather(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Weather || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Weather.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Weather ? item : Weather.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class GeneralClass {
	constructor({name='', description='', }={}){
		this.name=name;
		this.description=description;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}
